import agent from 'agent'

export default {
  fetch(integrationName) {
    return agent
      .get(`/integrations/${integrationName}`)
      .then(({ data }) => data)
  },

  fetchAll() {
    return agent.get('/integrations').then(({ data }) => data)
  }
}
